export const PAYMENT_GATEWAY_TYPES = {
  STRIPE: 'Stripe',
  BRAINTREE: 'Braintree',
  PAYPAL: 'Paypal',
  TOUCHNET: 'Touchnet',
  FAKE_GATEWAY: 'FakeGateway',
};

export const TOUCHNET_PAYMENT_TYPES = {
  CARD: 'card',
  ACH: 'ach',
};

export const STRIPE_PAYMENT_TYPES = {
  CARD: 'card',
  SEPA_DEBIT: 'sepa_debit',
  IDEAL: 'ideal',
  BANCONTACT: 'bancontact',
};

export const STRIPE_BANK_REDIRECT_PAYMENT_METHODS = {
  IDEAL: STRIPE_PAYMENT_TYPES.IDEAL,
  BANCONTACT: STRIPE_PAYMENT_TYPES.BANCONTACT,
};
